<style lang="scss"></style>

<template>
  <div id="modal-remove-pedido" class="modal modal-max-poli fade" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">ATENÇÃO!</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="card card-block shadow0 m0 pb0">
                <div class="title-block" v-if="pedido">
                  <h3 class="title adasd">
                    Tem certeza que deseja remover o pedido:
                    <span class="text-info">
                      #{{ pedido.protocolo }}
                      - {{ pedido.numPedido }}
                    </span> ?
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-primary"
            @click="remover"
            :disabled="enviando"
          >{{ enviando ? "REMOVENDO..." : "SIM" }}</button>
          <button type="button" class="btn btn-secondary" data-dismiss="modal">NÃO</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { showLoading, closeLoading } from '../../helpers';
import PedidoService from '../../services/PedidoService';

export default {
  name: 'modal-remove-pedido',
  data() {
    return {
      enviando: false,
      pedido: null,
    };
  },
  mounted() {
    // eslint-disable-next-line
    $('#modal-remove-pedido').on('hidden.bs.modal', () => {
      this.clear();
      this.$parent.removePedidoId = null;
    });

    if (this.$parent.removePedidoId === null) return;

    this.load();
  },
  methods: {
    clear() {
      this.enviando = false;
      this.pedido = null;
    },
    async load() {
      try {
        showLoading();

        if (this.$parent.removePedidoId === 0) return;

        this.pedido = await PedidoService.findById(
          this.$parent.removePedidoId,
        );
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        // eslint-disable-next-line
        $('#modal-remove-pedido').modal('show');
      }
    },
    async remover() {
      try {
        this.enviando = true;

        showLoading();

        await PedidoService.remove(this.pedido.id);

        this.$toast.success('Pedido removido com sucesso!');

        this.$emit('reload');

        // eslint-disable-next-line
        $('#modal-remove-pedido').modal('hide');
      } catch (error) {
        this.$eventBus.$emit('notificationError', error);
      } finally {
        closeLoading();

        this.enviando = false;
      }
    },
  },
};
</script>
